var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        width: "450px",
        visible: _vm.dialogVisible,
        "append-to-body": "",
        fullscreen: _vm.device === "mobile",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.dialogClose,
      },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "div",
              { staticClass: "avatar-container" },
              [
                _c("el-image", {
                  attrs: {
                    src: _vm.data.avatar,
                    "preview-src-list": [_vm.data.avatar],
                    fit: "cover",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-descriptions",
                {
                  attrs: {
                    "label-style": { fontWeight: 600 },
                    column: 1,
                    colon: false,
                    size: "medium",
                    border: "",
                  },
                },
                [
                  _c("el-descriptions-item", { attrs: { label: "ID" } }, [
                    _vm._v(_vm._s(_vm.data.id)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "昵称" } }, [
                    _vm._v(_vm._s(_vm.data.nickName)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "手机号" } }, [
                    _vm._v(_vm._s(_vm.data.mobile)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "分享码" } }, [
                    _vm._v(_vm._s(_vm.data.shareCode)),
                  ]),
                  _vm._t("default"),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.dialogClose } }, [
            _vm._v("取　消"),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("确　定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }